/**
 * Visit Schedule "Arms" helpers.
 *
 * We deliberately count ARMs by *display identity* (name) rather than raw array length.
 * In some versioning flows (e.g., promote → create new Dev version), the backend can
 * temporarily return multiple schedule records that collapse to a single visible ARM
 * in the UI (because the UI groups by `name`). In that case, actions like "Delete Arm"
 * must behave as if there is only one ARM.
 */

const normalizeArmName = name => (typeof name === 'string' ? name.trim().toLowerCase() : '')

export const getArmDisplayKey = arm => {
  const normalizedName = normalizeArmName(arm?.name)
  if (normalizedName) return normalizedName
  if (arm?.id !== undefined && arm?.id !== null) return String(arm.id)
  return null
}

export const countUniqueArms = (studyVisitSchedule = []) => {
  if (!Array.isArray(studyVisitSchedule) || studyVisitSchedule.length === 0) return 0
  const keys = new Set()
  studyVisitSchedule.forEach(arm => {
    const key = getArmDisplayKey(arm)
    if (key) keys.add(key)
  })
  return keys.size
}

export const hasMultipleArms = studyVisitSchedule => countUniqueArms(studyVisitSchedule) > 1

